import moment from "moment-timezone";
import {SPEAKING} from "@/common/courseTemplate";
// Type exam
export const COI_THI = 0
export const MARK_GENERAL = 1
export const MARK_SPEAKING = 2
export const RETEST = 3
export const MARK_TRIAL =  6
export const MARK_AI = 7
export const MARK_ENTRANCE_GENERAL = 8
// general là writing
export const MARK_ENTRANCE_SPEAKING = 9
// Status exam
export const PENDING = 0
export const SUCCESS = 1
export const HANDLE_CHEAT = 2
// Status attendance
export const PRESENT = 0
export const ABSENT = 1
export const NEED_ADDITIONAL = 2
export const TAKE_ATTENDANCE = 3
export const ATTENDANCE = 4

export class TaskPersonalModel {
    constructor(taskPersonal) {
        this.taskId = taskPersonal.id;
        this.type = taskPersonal.type;
        this.examForm = taskPersonal.exam_form;
        this.taskType = this.getTypeTaskLabel(taskPersonal.type);
        this.bgType = this.getBgType(taskPersonal.type)
        this.target = taskPersonal.handler;
        this.statusNum = taskPersonal.status
        this.status = this.getLabelStatus(taskPersonal.status);
        this.bgStatus = this.getBgStatus(taskPersonal.status)
        this.startDate = this.formatDate(taskPersonal.start_date);
        this.endDate = this.formatDate(taskPersonal.end_date);
        this.createdAt = this.formatDate(taskPersonal.created_at);
        this.showAction = this.showActionTask(taskPersonal.type)
        this.markingExamRetakeId = taskPersonal.marking_exam_retake_id
        this.markingExamShiftId = taskPersonal.marking_exam_shift_id
        this.markingExamRetakeId = taskPersonal.marking_exam_retake_id
        this.classroomId = taskPersonal?.classroom_id
        this.studentName = taskPersonal?.user_name
        this.assignedAt = this.formatDate(taskPersonal?.assigned_at)
        this.deadline = this.formatDate(taskPersonal?.deadline)
        this.examTypelabel = taskPersonal?.exam_shift_type == 'Thi đầu khóa' ? 'Thi đầu khóa' : taskPersonal?.exam_type_label
        this.examType = taskPersonal?.exam_type
        this.examShiftType = taskPersonal?.exam_shift_type
    }

    formatDate(value) {
        if (value) {
            return moment(value).format('HH:mm:ss DD-MM-YYYY');
        }
        return ''
    }

    getTypeTaskLabel(value) {
        switch (value) {
            case COI_THI:
                return 'Coi thi'
            case MARK_GENERAL:
                return 'Chấm General'
            case MARK_SPEAKING:
                return 'Chấm Speaking'
            case RETEST:
                return 'Thi lại'
            case MARK_TRIAL:
                return 'Chấm thi giữa khoá'
            case MARK_ENTRANCE_SPEAKING:
                return 'Chấm thi đầu khóa Speaking'
            case MARK_ENTRANCE_GENERAL:
                return 'Chấm thi đầu khóa General'
            default:
                return ''
        }
    }

    getBgType(type) {
        switch (type) {
            case COI_THI:
                return 'bg-teal-500';
            case MARK_GENERAL:
                return 'bg-yellow-500';
            case MARK_SPEAKING:
                return 'bg-blue-500';
            case MARK_TRIAL:
                return 'bg-success';
            case MARK_ENTRANCE_GENERAL:
                return 'bg-entrance-exam-general';
            case MARK_ENTRANCE_SPEAKING:
                return 'bg-entrance-exam-speaking';
            default: return '';
        }
    }

    getBgStatus(status) {
        switch (status) {
            case PENDING:
                return 'bg-yellow-500';
            case SUCCESS:
                return 'bg-success';
            case HANDLE_CHEAT:
                return 'bg-red-500';
        }
    }

    getLabelStatus(status) {
        switch (status) {
            case PENDING:
                return 'Cần làm';
            case SUCCESS:
                return 'Hoàn thành';
            case HANDLE_CHEAT:
                return 'Xử lý gian lận';
            default:
                return ''
        }
    }

    showActionTask(value) {
        switch (value) {
            case COI_THI:
                return COI_THI
            case MARK_GENERAL:
            case MARK_SPEAKING:
            case MARK_TRIAL:
            case MARK_AI:
            case MARK_ENTRANCE_GENERAL:
            case MARK_ENTRANCE_SPEAKING:    
                return SPEAKING
            default:
                return false;
        }
    }
}

export class AttendanceModel {
    constructor(student) {
        this.id = student.id;
        this.studentId = student.user?.id ? student.user?.id + 100000 : null;
        this.userId = student.user?.id ?? null
        this.name = student.user?.name ?? null;
        this.phone = student?.user?.phone ?? null;
        this.examCode = student.exam_code
        this.classroomId = student.classroom?.id ?? null;
        this.classroomName = student?.classroom?.name ?? null;
        this.status = this.getStatusAttendance(student?.status_verification);
        this.typeExam = student.typeExam;
        this.type = student.type_label;
        this.studentImage = student?.verification_image_url ?? null
        this.isFraud = !!student?.is_fraud
        this.isSuspected = !!student?.is_suspected
        this.typeOriginal = student.type;
    }
    getStatusAttendance(value) {
        switch (value) {
            case 0:
                return PRESENT
            case 1:
                return ABSENT
            case 2:
                return NEED_ADDITIONAL
            case 3:
                return TAKE_ATTENDANCE
            default:
                return ATTENDANCE
        }
    }
}

export class StudentCheatingModel {
    constructor(studentId, name, user_id, cheating_reason_id, description, marking_exam_shift_id, status, disabled, classroomId) {
        this.studentId = studentId
        this.name = name
        this.user_id = user_id
        this.cheating_reason_id = cheating_reason_id
        this.description = description
        this.marking_exam_shift_id = marking_exam_shift_id
        this.status = status
        this.disabled = disabled;
        this.classroomId = classroomId;
    }
}

export class StudentSkillModel {
    constructor(student) {
        this.name = student?.user_name ?? '';
        this.listening = student?.listening ?? 'Chưa nộp';
        this.bgStatus = this.setBgStatus(student.status_text)
        this.reading = student?.reading ?? 'Chưa nộp';
        this.speaking = student?.speaking ?? 'Chưa chấm';
        this.writing = student?.writing ?? 'Chưa chấm';
        this.status = student?.status_text ?? '';
        this.submittedAt = this.formatDate(student?.submitted_at) ?? '';
        this.gradedAt = this.formatDate(student?.graded_at) ?? 'Chưa chấm';
    }
    formatDate(value) {
        if (value) {
            return moment(value).format('HH:mm:ss DD-MM-YYYY');
        }
        return ''
    }
    setBgStatus(value) {
        switch (value) {
            case 'Hoàn thành':
                return 'bg-gradient__success'
            case 'Cần chấm':
                return 'bg-gradient__warning'
            default:
                return 'bg-gradient__info'
        }
    }
}
